<!-- 
CustTagEdit.vue
功能：客戶標籤管理(edit)
作者：i9400538 陳博承
完成：2021-10-19
-->
<template>
  <main>
    <tab-header />
    <div class="tab-pane active show">
      <form class="form">
        <section class="segment">
          <div class="p-b-1">
            <label class="title">客戶標籤定義與維護窗口</label>
          </div>

          <div class="row">
            <!-- 標籤ID -->
            <div class="col-12">
              <div class="form-group row">
                <label for="tag_id" class="col-2 text-right">標籤ID</label>
                <div class="col-2 d-flex">
                  <input
                    type="text"
                    maxlength="10"
                    :id="`cust-tag-id-${colKey}`"
                    :data-vv-name="`cust-tag-id-${colKey}`"
                    placeholder="請輸入標籤ID"
                    v-validate="'required'"
                    data-vv-as="標籤ID"
                    class="form-control"
                    v-model="form.tag_id"
                    :class="{ 'is-invalid': errors.has(`cust-tag-id-${colKey}`) }"
                    @input="checkInputCustTagId"
                    :disabled="editMode=='m' ? true : false"
                  />
                </div>
                <button
                  type="button"
                  @click="doGetTagName"
                  class="btn-use"
                  :class="editMode=='m' ? 'btn-use-disabled' : ''"
                >帶入資料</button>
              </div>
            </div>
            <!-- 標籤名稱 -->
            <div class="col-12">
              <div class="form-group row">
                <label for="tag_name" class="col-2 text-right">標籤名稱</label>
                <div class="col-2 d-flex">
                  <input
                    type="text"
                    maxlength="100"
                    :id="`cust-tag-name-${colKey}`"
                    :data-vv-name="`cust-tag-name-${colKey}`"
                    placeholder="請輸入標籤名稱"
                    v-validate="'required'"
                    data-vv-as="標籤名稱"
                    class="form-control"
                    v-model="form.tag_name"
                    alt="ch"
                    :class="{ 'is-invalid': errors.has(`cust-tag-name-${colKey}`) }"
                    disabled
                  />
                </div>
              </div>
            </div>
            <!-- 標籤顯示名稱 -->
            <div class="col-12">
              <div class="form-group row">
                <label for="tag_show_name" class="col-2 text-right">標籤顯示名稱</label>
                <div class="col-2 d-flex">
                  <input
                    type="text"
                    maxlength="100"
                    :id="`cust-tag-show-name-${colKey}`"
                    :data-vv-name="`cust-tag-show-name-${colKey}`"
                    placeholder="請輸入標籤顯示名稱"
                    v-validate="'required'"
                    data-vv-as="標籤顯示名稱"
                    class="form-control"
                    v-model="form.tag_show_name"
                    alt="ch"
                    :class="{ 'is-invalid': errors.has(`cust-tag-show-name-${colKey}`) }"
                    @input="checkInputTagShowName"
                  />
                </div>
              </div>
            </div>
            <!-- 標籤屬性 -->
            <div class="col-12">
              <div class="form-group row">
                <label for="ishot_name" class="col-2 text-right">標籤屬性</label>
                <div
                  class="radio radio-inline margin-left-10"
                  v-for="(single, index) in isHotRadio"
                  :key="`ishot-radio-${index}`"
                >
                  <input
                    type="radio"
                    :id="`ishot-radio-${index}`"
                    name="ishot-radio"
                    :value="single.value"
                    v-model="form.ishot"
                  />
                  <label :for="`ishot-radio-${index}`">{{ single.name }}</label>
                </div>
              </div>
            </div>
            <!-- 定義 -->
            <div class="col-12">
              <div class="form-group row">
                <label for="tag_agdef" class="col-2 text-right">定義</label>
                <div class="col-10 d-flex">
                  <textarea
                    maxlength="150"
                    :id="`tag_agdef-${colKey}`"
                    :data-vv-name="`tag_agdef-${colKey}`"
                    placeholder="請輸入定義"
                    v-model="form.tag_agdef"
                    v-validate="'required'"
                    data-vv-as="定義"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has(`tag_agdef-${colKey}`) }"
                    rows="5"
                  ></textarea>
                </div>
                <label for="tag_agdef" class="col-2 text-right"></label>
                <div class="col-10 d-flex">
                  <span>限150個字(中文、英文、數字、符號、空格)，目前已輸入{{form.tag_agdef.length}}個字</span>
                </div>
              </div>
            </div>
            <!-- 應用技巧 -->
            <div class="col-12">
              <div class="form-group row">
                <label for="tag_agusage" class="col-2 text-right">應用技巧</label>
                <div class="col-10 d-flex">
                  <textarea
                    maxlength="150"
                    :id="`tag_agusage-${colKey}`"
                    :data-vv-name="`tag_agusage-${colKey}`"
                    placeholder="請輸入應用技巧"
                    v-model="form.tag_agusage"
                    v-validate="'required'"
                    data-vv-as="應用技巧"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has(`tag_agusage-${colKey}`) }"
                    rows="5"
                  ></textarea>
                </div>
                <label for="tag_agusage" class="col-2 text-right"></label>
                <div class="col-10 d-flex">
                  <span>限150個字(中文、英文、數字、符號、空格)，目前已輸入{{form.tag_agusage.length}}個字</span>
                </div>
              </div>
            </div>
            <!-- 頭像圖檔 -->
            <div class="col-12">
              <div class="form-group row">
                <label class="col-2 text-right">頭像圖檔</label>
                <div class="col-10 d-flex">
                  <div v-if="form.picno && !isDelete_picno">
                    <span class="text">{{form.picno}}</span>
                    <button type="button" class="btn btn-red" @click="doDelete('picno')">刪除</button>
                  </div>
                  <div class="d-flex" v-else>
                    <input
                      id="file-upload-picno"
                      ref="file_picno"
                      type="file"
                      @change="changePicno()"
                    />
                    <input
                      type="text"
                      v-model="form.picno"
                      id="file-text"
                      class="form-control w-50 mr-2"
                      readonly
                    />
                    <label
                      for="file-upload-picno"
                      class="custom-file-upload btn btn-default m-0"
                    >上傳檔案</label>
                  </div>
                </div>
                <label for="picno" class="col-2 text-right"></label>
                <div class="col-10 d-flex">
                  <span>格式限定 : PNG、JPG，上限大小500KB</span>
                </div>
              </div>
            </div>
            <!-- 上架日期 -->
            <div class="col-12">
              <div class="form-group row">
                <label for="start_date" class="col-2 text-right">上架日期</label>
                <div class="col-10 d-flex">
                  <select
                    :id="`upload-year-${colKey}`"
                    :data-vv-name="`upload-year-${colKey}`"
                    v-validate="'required'"
                    data-vv-as="上架日期"
                    class="form-control form-control-inline"
                    :class="{ 'is-invalid': errors.has(`upload-year-${colKey}`) }"
                    v-model="form.start_date[0]"
                    @change="updateDate('upload',form.start_date[0], form.start_date[1])"
                  >
                    <option value>年份</option>
                    <option
                      v-for="(opt, y_opt_i) in yearOpt_upload"
                      :key="`upload-year-${y_opt_i}`"
                      :value="opt"
                    >{{opt - 1911}}年</option>
                  </select>

                  <span class="text">/</span>

                  <select
                    :id="`upload-month-${colKey}`"
                    :data-vv-name="`upload-month-${colKey}`"
                    v-validate="'required'"
                    data-vv-as="上架日期"
                    class="form-control form-control-inline"
                    :class="{ 'is-invalid': errors.has(`upload-month-${colKey}`) }"
                    v-model="form.start_date[1]"
                    @change="updateDate('upload',form.start_date[0], form.start_date[1])"
                  >
                    <option value>月份</option>
                    <option
                      v-for="(opt, m_opt_i) in monthOpt"
                      :key="`upload-month-${m_opt_i}`"
                      :value="opt"
                    >{{opt}}月</option>
                  </select>

                  <span class="text">/</span>

                  <select
                    :id="`upload-date-${colKey}`"
                    :data-vv-name="`upload-date-${colKey}`"
                    v-validate="'required'"
                    data-vv-as="上架日期"
                    class="form-control form-control-inline"
                    :class="{ 'is-invalid': errors.has(`upload-date-${colKey}`) }"
                    v-model="form.start_date[2]"
                    @change="updateDate('upload',form.start_date[0], form.start_date[1])"
                  >
                    <option value>日期</option>
                    <option
                      v-for="(opt, d_opt_i) in dateOpt_upload"
                      :key="`upload-date-${d_opt_i}`"
                      :value="opt"
                    >{{opt}}日</option>
                  </select>
                </div>
              </div>
            </div>
            <!--下架日期 -->
            <div class="col-12">
              <div class="form-group row">
                <label for="end-year" class="col-2 text-right">下架日期</label>
                <div class="col-6">
                  <select
                    @change="updateDate('end',form.end_date[0], form.end_date[1])"
                    name="end-year"
                    id="end-year"
                    class="form-control form-control-inline"
                    v-model="form.end_date[0]"
                  >
                    <option value>年份</option>
                    <option
                      v-for="(opt, y_opt_i) in yearOpt_end"
                      :key="`end-year-${y_opt_i}`"
                      :value="opt"
                    >{{opt - 1911}}年</option>
                  </select>

                  <span class="text">/</span>

                  <select
                    @change="updateDate('end',form.end_date[0], form.end_date[1])"
                    name="end-month"
                    id="end-month"
                    class="form-control form-control-inline"
                    v-model="form.end_date[1]"
                  >
                    <option value>月份</option>
                    <option
                      v-for="(opt, m_opt_i) in monthOpt"
                      :key="`end-month-${m_opt_i}`"
                      :value="opt"
                    >{{opt}}月</option>
                  </select>

                  <span class="text">/</span>

                  <select
                    @change="updateDate('end',form.end_date[0], form.end_date[1])"
                    name="end_date"
                    id="end-date"
                    class="form-control form-control-inline"
                    v-model="form.end_date[2]"
                  >
                    <option value>日期</option>
                    <option
                      v-for="(opt, d_opt_i) in dateOpt_end"
                      :key="`end-date-${d_opt_i}`"
                      :value="opt"
                    >{{opt}}日</option>
                  </select>
                  &nbsp;&nbsp;
                  <div class="checkbox checkbox-inline">
                    <input type="checkbox" v-model="form.noEndDate" id="chk-no-end-date" />
                    <label for="chk-no-end-date">無下架日期</label>
                  </div>
                </div>
              </div>
            </div>
            <!-- 附件上傳 -->
            <div class="col-12">
              <div class="form-group row">
                <label class="col-2 text-right">附件上傳</label>
                <div class="col-10 d-flex">
                  <label>最多三個。標題上限15字。內容格式限定:PNG、JPG、PDF(上限)大小5MB與網址，</label>
                  <label class="text-red">網址與上傳檔案內容僅能擇一。</label>
                </div>
              </div>
            </div>
            <!-- 附件一標題 -->
            <div class="col-12">
              <div class="form-group row">
                <label for="doc_showname_1" class="col-2 text-right">附件一標題</label>
                <div class="col-2 d-flex">
                  <input
                    type="text"
                    id="input_doc_showname_1"
                    maxlength="15"
                    class="form-control"
                    v-model="form.doc_showname_1"
                    alt="ch"
                    @input="checkInputShowName1"
                  />
                </div>
              </div>
            </div>
            <!-- 附件一內容 -->
            <div class="col-12">
              <div class="form-group row">
                <label class="col-2 text-right">附件一內容</label>
                <div class="col-10 d-flex">
                  <div v-if="form.doc_realname_1 && !isDelete_file1">
                    <span class="text">{{form.doc_realname_1}}</span>
                    <button type="button" class="btn btn-red" @click="doDelete('file1')">刪除</button>
                  </div>
                  <div class="d-flex" v-else>
                    <input
                      id="file-upload1"
                      ref="file_realname1"
                      type="file"
                      @change="changeInputFile1()"
                    />
                    <input
                      type="text"
                      v-model="form.doc_realname_1"
                      id="file1"
                      class="form-control w-50 mr-2"
                      readonly
                    />
                    <label for="file-upload1" class="custom-file-upload btn btn-default m-0">上傳檔案</label>
                  </div>
                </div>
              </div>
            </div>
            <!-- 附件一網址 -->
            <div class="col-12">
              <div class="form-group row">
                <label for="doc_weblink_1" class="col-2 text-right">附件一網址</label>
                <div class="col-2 d-flex">
                  <input
                    type="text"
                    id="input_doc_weblink_1"
                    maxlength="100"
                    class="form-control"
                    v-model="form.doc_weblink_1"
                    alt="ch"
                    @input="checkInputWeblink1"
                  />
                </div>
              </div>
            </div>
            <!-- 附件二標題 -->
            <div class="col-12">
              <div class="form-group row">
                <label for="doc_showname_2" class="col-2 text-right">附件二標題</label>
                <div class="col-2 d-flex">
                  <input
                    type="text"
                    id="input_doc_showname_2"
                    maxlength="15"
                    class="form-control"
                    v-model="form.doc_showname_2"
                    alt="ch"
                    @input="checkInputShowName2"
                  />
                </div>
              </div>
            </div>
            <!-- 附件二內容 -->
            <div class="col-12">
              <div class="form-group row">
                <label class="col-2 text-right">附件二內容</label>
                <div class="col-10 d-flex">
                  <div v-if="form.doc_realname_2 && !isDelete_file2">
                    <span class="text">{{form.doc_realname_2}}</span>
                    <button type="button" class="btn btn-red" @click="doDelete('file2')">刪除</button>
                  </div>
                  <div class="d-flex" v-else>
                    <input
                      id="file-upload2"
                      ref="file_realname2"
                      type="file"
                      @change="changeInputFile2()"
                    />
                    <input
                      type="text"
                      v-model="form.doc_realname_2"
                      id="file2"
                      class="form-control w-50 mr-2"
                      readonly
                    />
                    <label for="file-upload2" class="custom-file-upload btn btn-default m-0">上傳檔案</label>
                  </div>
                </div>
              </div>
            </div>
            <!-- 附件二網址 -->
            <div class="col-12">
              <div class="form-group row">
                <label for="doc_weblink_2" class="col-2 text-right">附件二網址</label>
                <div class="col-2 d-flex">
                  <input
                    type="text"
                    id="input_doc_weblink_2"
                    maxlength="100"
                    class="form-control"
                    v-model="form.doc_weblink_2"
                    alt="ch"
                    @input="checkInputWeblink2"
                  />
                </div>
              </div>
            </div>
            <!-- 附件三標題 -->
            <div class="col-12">
              <div class="form-group row">
                <label for="doc_showname_3" class="col-2 text-right">附件三標題</label>
                <div class="col-2 d-flex">
                  <input
                    type="text"
                    id="input_doc_showname_3"
                    maxlength="15"
                    class="form-control"
                    v-model="form.doc_showname_3"
                    alt="ch"
                    @input="checkInputShowName3"
                  />
                </div>
              </div>
            </div>
            <!-- 附件三內容 -->
            <div class="col-12">
              <div class="form-group row">
                <label class="col-2 text-right">附件三內容</label>
                <div class="col-10 d-flex">
                  <div v-if="form.doc_realname_3 && !isDelete_file3">
                    <span class="text">{{form.doc_realname_3}}</span>
                    <button type="button" class="btn btn-red" @click="doDelete('file3')">刪除</button>
                  </div>
                  <div class="d-flex" v-else>
                    <input
                      id="file-upload3"
                      ref="file_realname3"
                      type="file"
                      @change="changeInputFile3()"
                    />
                    <input
                      type="text"
                      v-model="form.doc_realname_3"
                      id="file3"
                      class="form-control w-50 mr-2"
                      readonly
                    />
                    <label for="file-upload3" class="custom-file-upload btn btn-default m-0">上傳檔案</label>
                  </div>
                </div>
              </div>
            </div>
            <!-- 附件三網址 -->
            <div class="col-12">
              <div class="form-group row">
                <label for="doc_weblink_3" class="col-2 text-right">附件三網址</label>
                <div class="col-2 d-flex">
                  <input
                    type="text"
                    id="input_doc_weblink_3"
                    maxlength="100"
                    class="form-control"
                    v-model="form.doc_weblink_3"
                    alt="ch"
                    @input="checkInputWeblink3"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="action text-right">
            <button type="button" @click.stop.prevent="doCancel()" class="btn btn-default">取消</button>
            <button type="button" @click.stop.prevent="doSubmit()" class="btn btn-primary">確認</button>
          </div>
        </section>
      </form>
    </div>
    <!-- 打開遮罩 -->
    <mxMask :open="mxMaskOpen" :content="mxMaskContent" />
  </main>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { commonMixin } from "@/mixins/common";

//component
import TabHeader from "@/desktop/components/backend/TabHeaderCustTag";
import mxMask from "@/desktop/components/mxMask";
//service
import { queryTagName, editCustTag } from "@/service";

export default {
  name: "CustTagEdit",
  mixins: [commonMixin],
  components: { TabHeader, mxMask },
  data() {
    return {
      editMode: "m", //編輯模式 (m:修改, i:新增)
      mxMaskOpen: false,
      mxMaskContent: "資料讀取中，請稍候...",
      yearOpt_upload: [],
      yearOpt_end: [],
      monthOpt: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      dateOpt_upload: [],
      dateOpt_end: [],
      form: {
        tag_id: "", //標籤ID
        ishot: "2", // (0:一般, 1:熱門, 2:新上架)
        tag_agdef: "", //標籤定義(給user看的)
        tag_agusage: "", //標籤應用場景與話術(給user看的)
        picno: "", //圖檔名稱
        tag_name: "", //標籤名稱
        tag_show_name:"", //標籤顯示名稱
        start_date: ["", "", ""], //標籤上架日期
        end_date: ["", "", ""], //標籤下架日期
        noEndDate: false, //無下架日期
        doc_showname_1: "", //附件1中文名稱
        doc_realname_1: "", //附件1檔案存放路徑及名稱
        doc_weblink_1: "", //附件1網址列
        doc_showname_2: "", //附件2中文名稱
        doc_realname_2: "", //附件2檔案存放路徑及名稱
        doc_weblink_2: "", //附件2網址列
        doc_showname_3: "", //附件3中文名稱
        doc_realname_3: "", //附件3檔案存放路徑及名稱
        doc_weblink_3: "" //附件3網址列
      },
      isHotRadio: [
        {
          name: "熱門",
          value: 1
        },
        {
          name: "新上架",
          value: 2
        },
        {
          name: "一般",
          value: 0
        }
      ],
      filePicno: {}, //檔案_圖檔
      fileRealname1: {}, //檔案_附件1
      fileRealname2: {}, //檔案_附件2
      fileRealname3: {}, //檔案_附件3
      init_picno: "", //圖檔初始值
      init_file1: "", //附件1初始值
      init_file2: "", //附件2初始值
      init_file3: "", //附件3初始值
      isDelete_picno: false, //是否執行檔案刪除 (圖檔名稱)
      isDelete_file1: false, //是否執行檔案刪除 (附件一)
      isDelete_file2: false, //是否執行檔案刪除 (附件二)
      isDelete_file3: false, //是否執行檔案刪除 (附件三)
      colKey: "1", //串欄位key用
      tagData: {} //整理後的標籤資料
    };
  },
  watch: {
    "form.noEndDate": function(val) {
      if (val) {
        this.form.end_date = ["", "", ""];
      }
    }
  },
  computed: {
    ...mapGetters(["UserInfo"])
  },
  methods: {
    ...mapActions(["setPageLock"]),
    //變更上傳圖檔
    changePicno() {
      let vm = this;
      if (!vm.$refs.file_picno.files || vm.$refs.file_picno.files.length == 0) {
        return; //瀏覽檔案點選取消不處理
      }
      vm.filePicno = vm.$refs.file_picno.files[0];
      let fileType = vm.filePicno.type;
      //檢查檔案類型 (只允許 image/png, image/jpeg)
      if (fileType.indexOf("png") !== -1 || fileType.indexOf("jpeg") !== -1) {
        //檢查檔案大小
        if (vm.$refs.file_picno.files[0].size > 500000) {
          vm.setToastMsg("檔案大小不得超過500K");
          vm.filePicno = {};
          vm.form.picno = "";
        } else {
          vm.filePicno = vm.$refs.file_picno.files[0];
          vm.form.picno = vm.filePicno.name;
          this.isDelete_picno = false;
        }
      } else {
        vm.setToastMsg("檔案格式只允許 jpg, png");
        vm.filePicno = {};
        vm.form.picno = "";
      }
    },
    //變更上傳附件1
    changeInputFile1() {
      let vm = this;
      if (
        !vm.$refs.file_realname1.files ||
        vm.$refs.file_realname1.files.length == 0
      ) {
        return; //瀏覽檔案點選取消不處理
      }
      vm.fileRealname1 = vm.$refs.file_realname1.files[0];
      let fileType = vm.fileRealname1.type;
      //檢查檔案類型 (只允許 application/pdf, image/png, image/jpeg)
      if (
        fileType.indexOf("pdf") !== -1 ||
        fileType.indexOf("png") !== -1 ||
        fileType.indexOf("jpeg") !== -1
      ) {
        //檢查檔案大小
        if (vm.$refs.file_realname1.files[0].size > 5000000) {
          vm.setToastMsg("檔案大小不得超過5MB");
          vm.fileRealname1 = {};
          vm.form.doc_realname_1 = "";
        } else {
          vm.fileRealname1 = vm.$refs.file_realname1.files[0];
          vm.form.doc_realname_1 = vm.fileRealname1.name;
          this.isDelete_file1 = false;
        }
      } else {
        vm.setToastMsg("檔案格式只允許pdf, jpg, png");
        vm.fileRealname1 = {};
        vm.form.doc_realname_1 = "";
      }
    },
    //變更上傳附件2
    changeInputFile2() {
      let vm = this;
      if (
        !vm.$refs.file_realname2.files ||
        vm.$refs.file_realname2.files.length == 0
      ) {
        return; //瀏覽檔案點選取消不處理
      }
      vm.fileRealname2 = vm.$refs.file_realname2.files[0];
      let fileType = vm.fileRealname2.type;
      //檢查檔案類型 (只允許 application/pdf, image/png, image/jpeg)
      if (
        fileType.indexOf("pdf") !== -1 ||
        fileType.indexOf("png") !== -1 ||
        fileType.indexOf("jpeg") !== -1
      ) {
        //檢查檔案大小
        if (vm.$refs.file_realname2.files[0].size > 5000000) {
          vm.setToastMsg("檔案大小不得超過5MB");
          vm.fileRealname2 = {};
          vm.form.doc_realname_2 = "";
        } else {
          vm.fileRealname2 = vm.$refs.file_realname2.files[0];
          vm.form.doc_realname_2 = vm.fileRealname2.name;
          this.isDelete_file2 = false;
        }
      } else {
        vm.setToastMsg("檔案格式只允許pdf, jpg, png");
        vm.fileRealname2 = {};
        vm.form.doc_realname_2 = "";
      }
    },
    //變更上傳附件3
    changeInputFile3() {
      let vm = this;
      if (
        !vm.$refs.file_realname3.files ||
        vm.$refs.file_realname3.files.length == 0
      ) {
        return; //瀏覽檔案點選取消不處理
      }
      vm.fileRealname3 = vm.$refs.file_realname3.files[0];
      let fileType = vm.fileRealname3.type;
      //檢查檔案類型 (只允許 application/pdf, image/png, image/jpeg)
      if (
        fileType.indexOf("pdf") !== -1 ||
        fileType.indexOf("png") !== -1 ||
        fileType.indexOf("jpeg") !== -1
      ) {
        //檢查檔案大小
        if (vm.$refs.file_realname3.files[0].size > 5000000) {
          vm.setToastMsg("檔案大小不得超過5MB");
          vm.fileRealname3 = {};
          vm.form.doc_realname_3 = "";
        } else {
          vm.fileRealname3 = vm.$refs.file_realname3.files[0];
          vm.form.doc_realname_3 = vm.fileRealname3.name;
          this.isDelete_file3 = false;
        }
      } else {
        vm.setToastMsg("檔案格式只允許pdf, jpg, png");
        vm.fileRealname3 = {};
        vm.form.doc_realname_3 = "";
      }
    },
    //檢查標籤ID
    checkInputCustTagId() {
      this.form.tag_id = this.form.tag_id.replace(/[^a-zA-Z0-9]+/g, "");
    },
    //檢查標籤顯示名稱
    checkInputTagShowName() {
      this.form.tag_show_name = this.form.tag_show_name.replace(
        /[<>!@#$^&,."'?%*;()+-/_{}[\]|~`=\\\s]/g,
        ""
      );
    },    
    //檢查附件1中文名稱
    checkInputShowName1() {
      this.form.doc_showname_1 = this.form.doc_showname_1.replace(
        /[<>!@#$^&,."'?%*;()+-/_{}[\]|~`=\\\s]/g,
        ""
      );
    },
    //檢查附件2中文名稱
    checkInputShowName2() {
      this.form.doc_showname_2 = this.form.doc_showname_2.replace(
        /[<>!@#$^&,."'?%*;()+-/_{}[\]|~`=\\\s]/g,
        ""
      );
    },
    //檢查附件3中文名稱
    checkInputShowName3() {
      this.form.doc_showname_3 = this.form.doc_showname_3.replace(
        /[<>!@#$^&,."'?%*;()+-/_{}[\]|~`=\\\s]/g,
        ""
      );
    },
    //去除附件1網址空白
    checkInputWeblink1() {
      this.form.doc_weblink_1 = this.form.doc_weblink_1.replace(/[\s]/g, "");
    },
    //去除附件2網址空白
    checkInputWeblink2() {
      this.form.doc_weblink_2 = this.form.doc_weblink_2.replace(/[\s]/g, "");
    },
    //去除附件3網址空白
    checkInputWeblink3() {
      this.form.doc_weblink_3 = this.form.doc_weblink_3.replace(/[\s]/g, "");
    },
    //上下架日期-下拉選單初始化
    updateDate(type, year, month) {
      if (type == "end") {
        this.form.noEndDate = false;
      }
      if (!year || !month) {
        return;
      }
      let dt = new Date(year, month, 0).getDate();
      if (type == "upload") {
        this.dateOpt_upload = [];
        for (let i = 0; i < dt; i++) {
          this.dateOpt_upload.push(i + 1);
        }
      } else {
        this.dateOpt_end = [];
        for (let i = 0; i < dt; i++) {
          this.dateOpt_end.push(i + 1);
        }
      }
    },
    //檔案刪除
    doDelete(type) {
      if (type == "picno") {
        this.form.picno = "";
        this.isDelete_picno = true;
        this.filePicno = {};
      } else if (type == "file1") {
        this.form.doc_realname_1 = "";
        this.isDelete_file1 = true;
        this.fileRealname1 = {};
      } else if (type == "file2") {
        this.form.doc_realname_2 = "";
        this.isDelete_file2 = true;
        this.fileRealname2 = {};
      } else if (type == "file3") {
        this.form.doc_realname_3 = "";
        this.isDelete_file3 = true;
        this.fileRealname3 = {};
      }
    },
    //取得標籤名稱
    doGetTagName() {
      if (this.editMode == "m" || !this.form.tag_id) {
        return; //編輯模式不做事
      }
      this.mxMaskContent = "資料讀取中，請稍候...";
      this.mxMaskOpen = true;
      queryTagName(this.UserInfo.id, this.form.tag_id).then(res => {
        this.mxMaskOpen = false;
        if (res.header && res.header.status == "200") {
          this.form.tag_name = res.body.result.result || "";
        } else {
          this.setToastMsg(res.header.message);
          this.form.tag_name = "";
        }
      });
    },
    //取消
    doCancel() {
      this.$toast.info({ title: "編輯標籤取消" });
      this.linkToCustTagView();
    },
    //導頁到客戶標籤列表
    linkToCustTagView() {
      this.$router.push({ path: "/backend/tab/6" });
    },
    //整理更新資料
    doFormatData() {
      let errMsg = [];

      this.tagData = Object.assign({}, this.form);

      if (
        this.form.noEndDate ||
        (!this.tagData.end_date[0] &&
          !this.tagData.end_date[1] &&
          !this.tagData.end_date[2])
      ) {
        //無下架日期
        this.tagData.end_date = "";
      } else if (
        this.tagData.end_date[0] &&
        this.tagData.end_date[1] &&
        this.tagData.end_date[2]
      ) {
        let month =
          this.tagData.end_date[1].toString().length == 1
            ? "0" + this.tagData.end_date[1].toString()
            : this.tagData.end_date[1].toString();
        let date =
          this.tagData.end_date[2].toString().length == 1
            ? "0" + this.tagData.end_date[2].toString()
            : this.tagData.end_date[2].toString();
        this.tagData.end_date =
          this.form.end_date[0] + "-" + month + "-" + date;
      } else {
        errMsg.push("請確認下架日期是否選取");
      }

      let uploadMonth =
        this.tagData.start_date[1].toString().length == 1
          ? "0" + this.tagData.start_date[1].toString()
          : this.tagData.start_date[1].toString();
      let uploadDate =
        this.tagData.start_date[2].toString().length == 1
          ? "0" + this.tagData.start_date[2].toString()
          : this.tagData.start_date[2].toString();
      this.tagData.start_date =
        this.form.start_date[0] + "-" + uploadMonth + "-" + uploadDate;
      //有下架日期
      if (this.tagData.end_date) {
        let d_start_date = new Date(this.tagData.start_date);
        let d_End_Date = new Date(this.tagData.end_date);
        if (d_start_date.getTime() > d_End_Date.getTime()) {
          errMsg.push("下架日期不得早於上架日期");
        }
      }
      if (!this.form.picno) {
        errMsg.push("請上傳頭像圖檔");
      }

      if (this.form.doc_realname_1 && this.form.doc_weblink_1) {
        errMsg.push("附件一檔案和網址只能擇一輸入");
      }

      if (this.form.doc_realname_2 && this.form.doc_weblink_2) {
        errMsg.push("附件二檔案和網址只能擇一輸入");
      }

      if (this.form.doc_realname_3 && this.form.doc_weblink_3) {
        errMsg.push("附件三檔案和網址只能擇一輸入");
      }

      if (
        this.form.doc_showname_1 &&
        !this.form.doc_realname_1 &&
        !this.form.doc_weblink_1
      ) {
        errMsg.push("請上傳附件一或輸入網址");
      } else if (
        !this.form.doc_showname_1 &&
        (this.form.doc_realname_1 || this.form.doc_weblink_1)
      ) {
        errMsg.push("附件一標題不可為空");
      }

      if (
        this.form.doc_showname_2 &&
        !this.form.doc_realname_2 &&
        !this.form.doc_weblink_2
      ) {
        errMsg.push("請上傳附件二或輸入網址");
      } else if (
        !this.form.doc_showname_2 &&
        (this.form.doc_realname_2 || this.form.doc_weblink_2)
      ) {
        errMsg.push("附件二標題不可為空");
      }

      if (
        this.form.doc_showname_3 &&
        !this.form.doc_realname_3 &&
        !this.form.doc_weblink_3
      ) {
        errMsg.push("請上傳附件三或輸入網址");
      } else if (
        !this.form.doc_showname_3 &&
        (this.form.doc_realname_3 || this.form.doc_weblink_3)
      ) {
        errMsg.push("附件三標題不可為空");
      }

      return errMsg;
    },
    //編輯模式下檢查資料內容
    doEditCheck() {
      if (this.editMode != "m") {
        return; //編輯模式才檢查
      }

      //需要處理上傳(Y/N)
      this.tagData.needUpload =
        this.filePicno.name ||
        this.fileRealname1.name ||
        this.fileRealname2.name ||
        this.fileRealname3.name
          ? "Y"
          : "N";

      //檢查圖檔
      if (this.filePicno.name && this.filePicno.name != this.init_picno) {
        //確認檔案是否異動過，有異動才要刪除舊有檔案
        this.tagData.needDeletePic = "Y";
        this.tagData.init_picno = this.init_picno;
      }

      //檢查附件1
      if (
        (this.fileRealname1.name &&
          this.fileRealname1.name != this.init_file1) ||
        (this.init_file1 && !this.form.doc_realname_1)
      ) {
        //確認附件1是否異動，有異動才要刪除舊有檔案
        this.tagData.needDeleteFile1 = "Y";
        this.tagData.init_file1 = this.init_file1;
      }

      //檢查附件2
      if (
        (this.fileRealname2.name &&
          this.fileRealname2.name != this.init_file2) ||
        (this.init_file2 && !this.form.doc_realname_2)
      ) {
        //確認附件2是否異動，有異動才要刪除舊有檔案
        this.tagData.needDeleteFile2 = "Y";
        this.tagData.init_file2 = this.init_file2;
      }

      //檢查附件3
      if (
        (this.fileRealname3.name &&
          this.fileRealname3.name != this.init_file3) ||
        (this.init_file3 && !this.form.doc_realname_3)
      ) {
        //確認附件3是否異動，有異動才要刪除舊有檔案
        this.tagData.needDeleteFile3 = "Y";
        this.tagData.init_file3 = this.init_file3;
      }
    },
    //確認
    doSubmit() {
      //檢核
      this.$validator.validateAll().then(el => {
        if (!el) {
          let errMsg = [];
          for (let i = 0; i < this.errors.items.length; i++) {
            errMsg.push(this.errors.items[i].msg);
          }
          let showErrMsg = [...new Set(errMsg)];
          showErrMsg.forEach(s => {
            this.$toast.info({ title: s }); //印出檢核後的錯誤訊息
          });
          return;
        }
        this.$validator.reset();
        let errMsg = this.doFormatData();
        if (errMsg && errMsg.length > 0) {
          errMsg.forEach(err => {
            this.$toast.info({ title: err }); //印出檢核後的錯誤訊息
          });
          return;
        }
        this.doEditCheck(); //檢查附件
        //通過檢查，開始更新資料
        this.mxMaskContent = "資料儲存中，請稍候...";
        this.mxMaskOpen = true;
        editCustTag(
          this.UserInfo.id,
          this.tagData.tag_id,
          this.tagData,
          this.editMode == "m" ? "1" : "2",
          this.filePicno.name ? this.filePicno : "",
          this.fileRealname1.name ? this.fileRealname1 : "",
          this.fileRealname2.name ? this.fileRealname2 : "",
          this.fileRealname3.name ? this.fileRealname3 : ""
        ).then(result => {
          this.mxMaskOpen = false;
          if (result.header && result.header.status == "200") {
            this.setToastMsg(result.header.message);
            //編輯成功, 導頁到客戶標籤管理頁面
            this.$router.push({
              name: "backend-tab6"
            });
          } else {
            this.setToastMsg(result.header.message);
          }
        });
      });
    },

    //初始化
    init() {
      let custTagData = this.$route.params.custTagData || "";
      this.editMode = this.$route.params.editMode || "";
      if (!custTagData && !this.editMode) {
        //未傳入資料和編輯模式
        this.linkToCustTagView();
        return;
      }

      if (this.editMode == "i") {
        this.initDateOption();
        return; //新增模式不帶入資料
      }

      this.form.tag_id = custTagData.tag_id; //標籤ID
      this.form.tag_name = custTagData.tag_name; //標籤名稱
      this.form.tag_show_name = custTagData.tag_show_name; //標籤顯示名稱
      this.form.ishot = custTagData.ishot || ""; //標籤屬性
      this.form.tag_agdef = custTagData.tag_agdef || ""; //定義
      this.form.tag_agusage = custTagData.tag_agusage || ""; //應用技巧
      this.form.picno = custTagData.picno || ""; //頭像圖檔
      this.form.doc_showname_1 = custTagData.doc_showname_1 || ""; //附件1中文名稱
      this.form.doc_realname_1 = custTagData.doc_realname_1 || ""; //附件1檔案存放路徑及名稱
      this.form.doc_weblink_1 = custTagData.doc_weblink_1 || ""; //附件1網址列
      this.form.doc_showname_2 = custTagData.doc_showname_2 || ""; //附件2中文名稱
      this.form.doc_realname_2 = custTagData.doc_realname_2 || ""; //附件2檔案存放路徑及名稱
      this.form.doc_weblink_2 = custTagData.doc_weblink_2 || ""; //附件2網址列
      this.form.doc_showname_3 = custTagData.doc_showname_3 || ""; //附件3中文名稱
      this.form.doc_realname_3 = custTagData.doc_realname_3 || ""; //附件3檔案存放路徑及名稱
      this.form.doc_weblink_3 = custTagData.doc_weblink_3 || ""; //附件3網址列

      this.init_picno = custTagData.picno; //圖檔初始值
      this.init_file1 = custTagData.doc_realname_1; //附件1初始值
      this.init_file2 = custTagData.doc_realname_2; //附件2初始值
      this.init_file3 = custTagData.doc_realname_3; //附件3初始值

      //上架日期 (專區起日)
      let start_date = custTagData.tag_startdate || ""; //上架日期
      if (start_date) {
        let start_dateArr = start_date.split("-");
        this.form.start_date[0] = start_dateArr[0]; //年
        if (parseInt(start_dateArr[1]) > 9) {
          this.form.start_date[1] = start_dateArr[1]; //月
        } else {
          this.form.start_date[1] = start_dateArr[1].replace("0", ""); //月 (去除0)
        }
        if (parseInt(start_dateArr[2]) > 9) {
          this.form.start_date[2] = start_dateArr[2]; //日
        } else {
          this.form.start_date[2] = start_dateArr[2].replace("0", ""); //日 (去除0)
        }
      }
      //下架日期 (專區迄日)
      let end_date = custTagData.tag_enddate || "";
      if (end_date) {
        let end_dateArr = end_date.split("-");
        this.form.end_date[0] = end_dateArr[0]; //年
        if (parseInt(end_dateArr[1]) > 9) {
          this.form.end_date[1] = end_dateArr[1]; //月
        } else {
          this.form.end_date[1] = end_dateArr[1].replace("0", ""); //月 (去除0)
        }
        if (parseInt(end_dateArr[2]) > 9) {
          this.form.end_date[2] = end_dateArr[2]; //日
        } else {
          this.form.end_date[2] = end_dateArr[2].replace("0", ""); //日 (去除0)
        }
      }
      this.initDateOption();
      if (!end_date) {
        this.form.noEndDate = true; //無下架日期
      }
    },
    //日期下拉選單初始化
    initDateOption() {
      let thisYear = window.moment().year(); //今年
      //上架日期
      if (this.form.start_date[0]) {
        let uploadYear = parseInt(this.form.start_date[0]);
        for (let s = uploadYear - 2; s <= uploadYear + 2; s++) {
          this.yearOpt_upload.push(s);
        }
      } else {
        for (let s = thisYear - 2; s <= thisYear + 2; s++) {
          this.yearOpt_upload.push(s);
        }
      }
      //下架日期
      if (this.form.end_date[0]) {
        let endYear = parseInt(this.form.end_date[0]);
        for (let s = endYear - 2; s <= endYear + 2; s++) {
          this.yearOpt_end.push(s);
        }
      } else {
        for (let s = thisYear - 2; s <= thisYear + 2; s++) {
          this.yearOpt_end.push(s);
        }
      }
      this.updateDate(
        "upload",
        this.form.start_date[0],
        this.form.start_date[1]
      );
      this.updateDate("end", this.form.end_date[0], this.form.end_date[1]);
    }
  },
  mounted() {
    this.init();
    this.registerHanlink();
  }
};
</script>

<style scoped>
input[type="file"] {
  display: none;
}
.custom-file-upload {
  border: 1px solid orange;
  display: inline-block;
  padding: 6px 12px;
  cursor: pointer;
}

.select-width {
  width: 150px;
}

.span-margin-top {
  margin-top: 12px;
}

textarea {
  resize: none;
}

.margin-left-10 {
  margin-left: 10px;
  margin-right: 0px;
}

.btn-use {
  border: 0px;
  color: #ffffff;
  background-color: #00a318;
  padding: 5px;
  margin: 5px;
  font-size: 16px;
  text-align: center;
  cursor: pointer;
  text-decoration: none;
}

.btn-use-disabled {
  background-color: #6c6c6c;
  cursor: default;
}

.p-b-1 {
  padding-bottom: 1rem;
  padding-left: 12%;
}

.title {
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 0.5rem;
  font-family: inherit;
  line-height: 1.2;
}

.w-50 {
  width: 50%;
}
</style>
